import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import {
    RdsBadgeModule,
    RdsButtonModule,
    RdsCheckboxModule,
    RdsDatepickerModule,
    RdsDividerModule,
    RdsDropdownModule,
    RdsFormFieldModule,
    RdsIconsModule,
    RdsProgressBarModule,
    RdsProgressSpinnerModule,
    RdsTooltipModule,
    RdsTreeModule,
} from '@rds/angular-components';

import { DateRangeSelectorComponent } from './date-range-selector/date-range-selector.component';
import { FilterSearchSelectorComponent } from './filter-search-selector/filter-search-selector.component';
import { FilterTreeSelectorComponent } from './filter-tree-selector/filter-tree-selector.component';
import { ScrollerModule } from './scroller/scroller.module';
import { SearchBarComponent } from './search-bar/search-bar.component';
import { SimpleCardComponent } from './simple-card/simple-card.component';
import { SortingButtonsStackComponent } from './sorting-buttons-stack/sorting-buttons-stack.component';
import { TypeaheadInputComponent } from './typeahead-input/typeahead-input.component';

@NgModule({
    declarations: [
        SimpleCardComponent,
        SortingButtonsStackComponent,
        FilterSearchSelectorComponent,
        DateRangeSelectorComponent,
        FilterTreeSelectorComponent,
        TypeaheadInputComponent,
        SearchBarComponent,
    ],
    imports: [
        CommonModule,
        RdsDropdownModule,
        RdsTreeModule,
        RdsCheckboxModule,
        RdsIconsModule,
        RdsFormFieldModule,
        RdsButtonModule,
        RdsDividerModule,
        ReactiveFormsModule,
        RdsProgressSpinnerModule,
        RdsProgressBarModule,
        FormsModule,
        ScrollerModule,
        RdsBadgeModule,
        RdsDatepickerModule,
        RdsTooltipModule
    ],
    exports: [
        SimpleCardComponent,
        SortingButtonsStackComponent,
        FilterSearchSelectorComponent,
        DateRangeSelectorComponent,
        FilterTreeSelectorComponent,
        TypeaheadInputComponent,
        SearchBarComponent,
    ],
})
export class InternalComponentsModule {}
